var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticStyle: {
          background: "#fff",
          "font-size": "16px",
          "line-height": "30px",
          "padding-bottom": "30px"
        }
      },
      [
        _c(
          "table",
          {
            staticStyle: {
              color: "#000000",
              "font-size": "16px",
              "font-weight": "400",
              width: "700px"
            },
            attrs: { align: "center" }
          },
          [
            _c("tbody", [
              _c("tr", [
                _c("td", { attrs: { align: "left" } }, [
                  _vm._v(" \n        "),
                  _c(
                    "p",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { align: "center" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "20px" } }, [
                        _c("strong", { staticStyle: { "font-size": "20px" } }, [
                          _vm._v("十堰市卫生界学会办公室简介")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { align: "center" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v(" ")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "text-indent": "2em", "font-size": "16px" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v(
                          "十堰市卫生界学会办公室直属市卫生健康委员会领导，是十堰市卫生界学会（协会）的综合办事机构。办公室遵循“组织、协调、指导、服务”的原则，以习近平新时代中国特色社会主义思想为指导,坚持党的领导,贯彻执行国家卫生健康、科学技术方针政策，围绕国家、省、市卫生健康工作有关任务和科学技术开展工作，成为发展我市医学科学技术事业的重要社会力量。"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { align: "left" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _c("strong", { staticStyle: { "font-size": "20px" } }, [
                          _vm._v("主要职责")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: {
                        "text-align": "left",
                        "text-indent": "2em",
                        "font-size": "16px"
                      },
                      attrs: { align: "left" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v(
                          "拟定实施全市继续医学教育、卫生建康专业技术人员培训。管理全市医疗卫生学会社团组织，负责卫生界各学会的计划、组织和学术活动安排。组织开展全市卫生系统学术论文、科研成果及主管部门委托交办的专业技术等评选、评审、鉴定和推荐申报工作。承担全市医疗事故技术鉴定、免疫预防接种异常反应鉴定及职业病诊断鉴定的日常工作。组织开展医师定期考核等工作。承办政府及有关部门委托的工作任务；推动医学科研成果的转化和应用；向政府反映医学科技工作者的意见和要求。"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { align: "left" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _c("strong", { staticStyle: { "font-size": "20px" } }, [
                          _vm._v("社团组织")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("strong", { staticStyle: { "font-size": "20px" } }, [
                        _c("span", { staticStyle: { "font-size": "16px" } }, [
                          _vm._v("十堰市卫生界一级学会（协会）")
                        ])
                      ]),
                      _c("span", { staticStyle: { "font-size": "16px" } })
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市医学会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市医师协会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市医院协会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市预防医学会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市护理学会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市中医学会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市中西医结合学会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市医学伦理学会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市康复医学会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市针灸推拿学会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市抗癌协会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市医院健康管理学会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("十堰市卫生统计与信息学会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "font-size": "16px", "text-indent": "2em" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v(" 十堰市心理卫生协会")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c("p", [
                    _c("span", { staticStyle: { "font-size": "16px" } }, [
                      _vm._v(" ")
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "text-align": "center" },
                      attrs: { align: "center" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _c("strong", { staticStyle: { "font-size": "20px" } }, [
                          _vm._v("十堰市卫生界学会办公室")
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { align: "left" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("地 址：十堰市柳林路46号")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { align: "left" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("邮 编：442000")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { align: "left" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("电 话：0719-8652453")
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "p",
                    {
                      staticStyle: { "text-align": "left" },
                      attrs: { align: "left" }
                    },
                    [
                      _c("span", { staticStyle: { "font-size": "16px" } }, [
                        _vm._v("邮 箱：sy8652453@126.com")
                      ])
                    ]
                  )
                ])
              ])
            ])
          ]
        )
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-039c5b43", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-039c5b43","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/About.vue
// module id = null
// module chunks = 